import React, { useState } from 'react';
import { Link, useParams } from "react-router-dom";
import moment from 'moment';
import MerchantDeleteButton from '../Merchant/MerchantDeleteModal';
import { useTranslation } from 'react-i18next';
import { Dropdown, Radio } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './Merchant.scss';
import { LoadingOutlined } from '@ant-design/icons';
import cn from 'classnames';
import useWindowSize from '../../utils/resizeHook';
import { ReactComponent as MoreSVG } from '../../img/default-svg/more.svg';
import { identity } from '../../utils/getIdentity';

const Merchant = ({ merchant, isLastMerchant, userRole, quickNetworkSwitcherState, changeMerchantNetwork, type = 'user' }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const { isSm } = useWindowSize();
  const { userId } = useParams();
  const { t } = useTranslation();

  const language = localStorage.getItem('cpayAppLang');

  return (
    <div
      className={cn(`merchant-item merchant-item-${identity}`, {
        [`testnet testnet-${identity}`]: merchant.typeNetwork.toLowerCase() === 'testnet',
        [`mainnet mainnet-${identity}`]: merchant.typeNetwork.toLowerCase() === 'mainnet',
      })}
    >
      <div className={`merchant-item__name merchant-item__name-${identity}`}>
        <h2>{merchant.name}</h2>
        <p>{merchant.notificationEmail ? merchant.notificationEmail : t('merchants.notificationEmailNotSpecified')}</p>
      </div>
      {type === 'admin' && (
        <div
          className={`${type === 'admin' && 'merchant-item__networks-button--type'} merchant-item__networks-button merchant-item__networks-button-${identity} ${
            isDropdownVisible ? "merchant-item__networks-button_hover" : ""
          } merchant-item__networks-button_${merchant.typeNetwork.toLowerCase()} merchant-item__networks-button_${merchant.typeNetwork.toLowerCase()}-${identity}`}
        >
          {t(merchant.typeNetwork.toLowerCase())}
          {type !== 'admin' && (
            <div>
              {quickNetworkSwitcherState?.fetching && quickNetworkSwitcherState?.merchantId === merchant._id ? (
                <LoadingOutlined className={`spin-${identity}`} />
              ) : (
                <DownOutlined />
              )}
            </div>
          )}
        </div>
      )}
      {!isSm && type !== "admin" && (
        <div className="merchant-item__network">
          <Dropdown
            visible={isDropdownVisible}
            onVisibleChange={isVisible => setIsDropdownVisible(isVisible)}
            overlay={
              <div className={`merchant-item__networks-dropdown merchant-item__networks-dropdown-${identity}`}>
                <Radio.Group
                  defaultValue={merchant.typeNetwork}
                  onChange={e => {
                    changeMerchantNetwork(merchant._id, { typeNetwork: e.target.value });
                  }}
                >
                  <Radio value="mainnet">{t("text.mainnet")}</Radio>
                  <Radio value="testnet">{t('text.testnet')}</Radio>
                </Radio.Group>
              </div>
            }
          >
            <div
              className={`merchant-item__networks-button merchant-item__networks-button-${identity} ${
                isDropdownVisible ? `merchant-item__networks-button_hover merchant-item__networks-button_hover-${identity}` : ''
              } merchant-item__networks-button_${merchant.typeNetwork.toLowerCase()} merchant-item__networks-button_${merchant.typeNetwork.toLowerCase()}-${identity}`}
            >
              {t(`admin.${merchant.typeNetwork.toLowerCase()}`)}
              {quickNetworkSwitcherState?.fetching && quickNetworkSwitcherState?.merchantId === merchant._id ? (
                <LoadingOutlined className={`spin-${identity}`} />
              ) : (
                <DownOutlined />
              )}
            </div>
          </Dropdown>
        </div>
      )}
      {!isSm && (
        <div className={`merchant-item__date merchant-item__date-${identity}`}>
          {t(moment(merchant.createdAt).format('MMMM').toLowerCase())}{' '}
          {moment(merchant.createdAt).format('D, YYYY, HH:mm')}
        </div>
      )}
      <div className="merchant-item__wallets">
        <Link to={type !== 'admin' ? `/merchants/wallets/${merchant._id}` : `/admin/merchants/wallets/${userId}/${merchant._id}`} className={`merchant-item__wallets-button merchant-item__wallets-button-${identity} ${language === 'es' && 'merchant-item__wallets-button-width'}`}>
          {t('merchants.merchantWallets')}
        </Link>
        {userRole?.includes('corporate') && (
          <Link to={type !== 'admin' ? `/merchants/clients/${merchant._id}` : `/admin/merchants/clients/${userId}/${merchant._id}`} className={`merchant-item__wallets-button merchant-item__wallets-button-${identity} ${language === 'es' && 'merchant-item__wallets-button-width'}`}>
            {t('merchants.clientWallets')}
          </Link>
        )}
      </div>
      {/*{!isSm && (
        <div className={`merchant-item__type merchant-item__type-${identity}`}>{userRole.includes('corporate') ? t('business') : t('individual')}</div>
      )}*/}
      {type !== 'admin' && (
        <div className="merchant-item__more">
          <Dropdown
            trigger={['click']}
            destroyPopupOnHide={true}
            placement="bottomRight"
            overlay={
              <div className={`merchant-item__more-dropdown merchant-item__more-dropdown-${identity}`}>
                <Link to={`/merchants/edit/${merchant._id}`} className={`merchant-item__more-dropdown-edit merchant-item__more-dropdown-edit-${identity}`}>
                  {t('edit')}
                </Link>
                <div className={`merchant-item__more-dropdown-delete merchant-item__more-dropdown-delete-${identity}`} onClick={() => setShowDelete(true)}>
                  {t('delete')}
                </div>
              </div>
            }
          >
            <div className={`merchant-item__more-icon merchant-item__more-icon-${identity}`}>
              <MoreSVG />
            </div>
          </Dropdown>
        </div>
      )}
      {type !== 'admin' && (
        <MerchantDeleteButton
          merchantId={merchant._id}
          merchantName={merchant.name}
          isLastMerchant={isLastMerchant}
          showDelete={showDelete}
          setShowDelete={setShowDelete}
        />
      )}
    </div>
  );
};

export default Merchant;
